import { CustomCellEditorProps } from "ag-grid-react";
import LBSSelectField from "components/lbs-select-field/lbs-select-field";
import { useEffect, useState } from "react";

interface LBSFieldCellEditorProps extends CustomCellEditorProps {
  initialValue: { id: string; path: string }[];
  onValueChange: (selectedIds: { id: string; path: string }[]) => void;
  context: any;
}

export function LBSFieldCellEditor({
  initialValue,
  onValueChange,
  context
}: LBSFieldCellEditorProps) {
  const { LBSOptionsMaster, LBSDataInTreeFormat, projectDetails } = context;

  const [open, setOpen] = useState(false);
  const [selectedLBSIds, setSelectedLBSIds] = useState<any>([]);

  useEffect(() => {
    setOpen(true);
    setSelectedLBSIds(
      initialValue?.length > 0
        ? initialValue.map((location: any) => location.id)
        : []
    );
  }, [initialValue]);

  return (
    <div className="w-full !h-full flex items-center justify-center leading-none">
      <LBSSelectField
        onChange={(selectedIds: string[]) => {
          setSelectedLBSIds(selectedIds);
          const newLocations = selectedIds.map((locationId: string) => {
            const location = LBSOptionsMaster.find(
              (option: any) => option.value === locationId
            );

            return {
              id: location?.value || "",
              path: location?.label || ""
            };
          });
          onValueChange(newLocations);
        }}
        open={open}
        autoFocus
        initialValues={selectedLBSIds}
        LBSOptionsMaster={LBSOptionsMaster}
        LBSDataInTreeFormat={LBSDataInTreeFormat}
        selectedLBSOptions={[]}
        projectId={projectDetails.id}
      />
    </div>
  );
}
